<template>
  <section class="sections">
    <v-container>
      <v-row align="center">
        <v-col>
          <v-divider color="white" inset></v-divider>
        </v-col>
        <v-col class="ma-auto text-center">
          <span class="text-sm-h4 text-uppercase details--title">Kata Pengantar</span>
        </v-col>
        <v-col>
          <v-divider class="ml-0" color="white" inset></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mt-10">
          <swiper class="swiper testimonials" :options="swiperOption">
            <swiper-slide v-for="(user, index) in users" :key="index">
              <figure class="text-center">
                <img
                  src="@/assets/img/testimoni.png"
                  class="rounded-circle swiper-blur"
                  width="100"
                />
                <v-col class="swiper-hidden">
                  <p class="text-h5">
                    {{user.name}}
                    <br />
                    <span class="text-h6 font-weight-bold">
                      {{user.title}}
                    </span>
                  </p>
                  <figcaption class="text-subtitle-1 swiper-line">
                    <i>
                      {{user.preface}}
                    </i>
                  </figcaption>
                </v-col>
              </figure>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Testimonial",
  data() {
    return {
      users: [
        {
          name: 'Hilmar Farid, Ph.D.',
          title: 'Direktur Jenderal Kebudayaan',
          preface: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin nec tempor libero. In rhoncus quam ut pretium placerat. Nam non placerat elit, et accumsan nisi. In id ipsum venenatis, tristique magna vitae, consequat lectus. Donec sed consequat tortor"'
        },
        {
          name: 'Dra. Sri Hartini, M.Si.',
          title: 'Kepala Museum Nasional Indonesia',
          preface: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin nec tempor libero. In rhoncus quam ut pretium placerat. Nam non placerat elit, et accumsan nisi. In id ipsum venenatis, tristique magna vitae, consequat lectus. Donec sed consequat tortor"'
        }
      ],
      swiperOption: {
        loop: true,
        slidesPerView: 3,
        pagination: {
          // el: ".swiper-pagination",
          // dynamicBullets: true
        },
        paginationClickable: true,
        centeredSlides: true,
        // spaceBetween: 5,
        autoHeight: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          640: {
            slidesPerView: 2
          },
          320: {
            slidesPerView: 1
          }
        }
      }
    };
  }
};
</script>
